import axios from 'axios'
import _ from 'lodash'

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

const csrfToken = () => document.querySelector('meta[name="csrf-token"]').getAttribute('content')

const execute = (methodString, url, data, inputHeaders, params) => {
  const method = _.upperCase(methodString)

  let headers = Object.assign({ Accept: 'application/json' }, inputHeaders)

  if (method === 'POST' || method === 'PATCH' || method === 'DELETE') {
    headers = Object.assign({}, headers, { 'X-CSRF-Token': csrfToken() })
  }

  return axios({
    method,
    url,
    params,
    responseType: 'json',
    headers,
    data
  }).catch((error) => {
    console.log(error)
    throw error
  })
}

const cloudhelpExecute = execute
const cloudhelpGet = (url, params) => execute('GET', url, null, null, params)
const cloudhelpPost = (url, data, headers) => execute('POST', url, data, headers)
const cloudhelpPatch = (url, data, headers) => execute('PATCH', url, data, headers)
const cloudhelpPut = (url, data, headers) => execute('PUT', url, data, headers)
const cloudhelpDelete = (url, headers) => execute('DELETE', url, null, headers)

export {
  cloudhelpExecute,
  cloudhelpGet,
  cloudhelpPost,
  cloudhelpPatch,
  cloudhelpPut,
  cloudhelpDelete
}
